import { useState } from "react";

export const useStateFormHandling = () => {

    const [formData, setFormData] = useState({
        name: "",
        countryId: "",
        code: "",
        active: true,
        iplStateId: "",
        nameStatus: "unchecked",
        countryIdStatus: "unchecked",
        codeStatus: "unchecked",
        iplStateIdStatus: "unchecked",
    });  
    
    const handleChange = (event, selectEvent) => {
        let formState = {...formData};
        //select dropdown
        if (event?.target === undefined && selectEvent){
            switch (selectEvent.name){
                case "countryId":
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    break;
                }
            formState[selectEvent.name] = event;
        }
        //input field
        else if (event && event.target){
            switch (event.target.name){
                case "name": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    break;
                }
                case "code": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    break;
                }
                case "iplCountryId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    };


    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.nameStatus === "success" &&
        formData.codeStatus === "success" &&
        formData.countryIdStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }
        
        return allowSubmit;
    };


  return {
    formData,
    setFormData,
    handleChange,
    checkAllFields
  };
};
